export default function stagingSiteDetailsReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_STAGING_SITE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_STAGING_SITE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_STAGING_SITE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}